import { defineAction, object, string } from '~/prix'
import getNotificationSettings from './getNotificationSettings.action.json'

const getNotificationSettingsDefinition = defineAction({
  ...getNotificationSettings,
  input: object({}),
  output: object({
    userEmail: string(),
    stateAbbreviation: string(),
    tsSebraeApp: string(),
    tsSebraeAppAlerts: string(),
    tsAllCourses: string(),
    tsAllCoursesAlerts: string(),
    tsPortfolioCourses: string(),
    tsPortfolioCoursesAlerts: string(),
    tsIndividualCourses: string(),
    tsIndividualCoursesAlerts: string(),
    tsAli: string(),
    tsAliAlerts: string(),
    tsBusinessOpening: string(),
    tsBusinessOpeningAlerts: string(),
    tsBusinessClosing: string(),
    tsBusinessClosingAlerts: string(),
  }),
})

export default getNotificationSettingsDefinition
